var exports = {
  "cS": "CreatePollModal.module__pollForm___cUxFQT",
  "GA": "CreatePollModal.module__answers___cUxFQT",
  "Hx": "CreatePollModal.module__modalFooter___cUxFQT",
};

module.exports = exports;
